module.exports = __webpack_public_path__ + "static/media/EdinburgIL_1-576w.747956e6.jpg";